export default __webpack_public_path__ + "media/images/blue-quotemark-87220eea4e5e51af1713f8652e5df62c.svg";